import PageRouter from '../page/@config/router';
import FooterRouter from '../footer/@config/router';
import HeaderRouter from '../header/@config/router';

export default {
    path: 'body',
    component: () => import('../Body.vue'),
    children: [
        PageRouter,
        HeaderRouter,
        FooterRouter
    ]
};